import { atom } from 'jotai';

/**
 * Per-session suppression: every "not now" exit (route away, support, Esc,
 * backdrop, close X). "OK" is permanent and goes through `seen_modals` instead.
 */
export const healthNzMigrationPromptSuppressedAtom = atom(false);
